import React from 'react';
import { useSelector } from 'react-redux';

import AiSummary from 'components/ui/ai_summary';
import type { ModelOption } from 'components/ui/ai_summary/model_comparison';

export default function DealAiSummary() {
  const adminOnly: boolean = useSelector((state: any) => state.features.adminOnly ?? false);
  const availableModels: ModelOption[] = useSelector((state: any) => state.availableSummaryModels || []);
  const path: string | null = useSelector((state: any) => (
    state.features.aiSummary ? state.paths.aiSummary : null
  ));

  if (!path) {
    return null;
  }

  return (
    <AiSummary
      availableModels={availableModels}
      errorMessage="We couldn't generate a summary for this deal."
      features={{ adminOnly }}
      path={path}
    />
  );
}
